(() => {
  const SIZE_SELECTOR = 'select[name="properties[AU size]"]';

  function buildSizeButtons(builder) {
    const select = builder.querySelector(SIZE_SELECTOR);
    if (!select || select.dataset.baSizeButtonsReady === 'true') return;

    select.dataset.baSizeButtonsReady = 'true';
    const wrapper = select.closest('.ba-order-field');
    const fieldset = document.createElement('fieldset');
    fieldset.className = 'ba-size-picker';

    const legend = document.createElement('legend');
    legend.className = 'ba-size-picker__legend';
    legend.innerHTML = '<span>Australian size</span><small>Choose one</small>';

    const grid = document.createElement('div');
    grid.className = 'ba-size-picker__grid';
    const formId = select.getAttribute('form');
    const selectedValue = select.value;

    [...select.options]
      .filter((option) => option.value)
      .forEach((option, index) => {
        const label = document.createElement('label');
        label.className = 'ba-size-button';

        const input = document.createElement('input');
        input.type = 'radio';
        input.name = select.name;
        input.value = option.value;
        input.id = `${builder.id || 'ba-order'}-size-${index}`;
        input.required = true;
        input.dataset.baRequired = 'true';
        input.disabled = select.disabled;
        if (formId) input.setAttribute('form', formId);
        if (option.value === selectedValue) input.checked = true;

        const face = document.createElement('span');
        face.textContent = option.textContent.replace(/^AU\s*/i, '');
        face.setAttribute('aria-hidden', 'true');

        label.append(input, face);
        grid.append(label);
      });

    fieldset.append(legend, grid);
    select.required = false;
    select.disabled = true;

    if (wrapper) wrapper.replaceWith(fieldset);
    else select.replaceWith(fieldset);
  }

  function buildProductInformation(builder) {
    const productDetails = builder.closest('.product-details');
    if (!productDetails || productDetails.querySelector('[data-ba-product-information]')) return;

    const buyButtons = productDetails.querySelector('.buy-buttons-block');
    if (!buyButtons) return;

    const descriptionBlocks = [...productDetails.querySelectorAll('.text-block.rte')]
      .filter((element) => element.textContent.trim());
    const descriptionBlock = descriptionBlocks.at(-1);
    const descriptionHtml = descriptionBlock?.innerHTML?.trim() ||
      '<p>Handmade by Alice in a limited fabric run. Choose a standard AU size or made to measure.</p>';

    const information = document.createElement('div');
    information.className = 'ba-product-information';
    information.dataset.baProductInformation = 'true';
    information.innerHTML = `
      <details class="ba-product-accordion" open>
        <summary><span>Fit &amp; sizing</span></summary>
        <div class="ba-product-accordion__content">
          <div class="ba-product-accordion__description">${descriptionHtml}</div>
          <p>Use your body measurements rather than your usual store size. Choose AU 6–20, or select made to measure for an additional $20.</p>
          <p class="ba-product-accordion__links"><a href="/pages/sizing">View the size guide</a><a href="/pages/made-to-measure">How to measure</a></p>
        </div>
      </details>
      <details class="ba-product-accordion">
        <summary><span>Fabric &amp; care</span></summary>
        <div class="ba-product-accordion__content">
          <p>This piece uses the limited fabric shown in the product photos. Fabric composition, stretch and care can vary between Alice's small fabric runs.</p>
          <p>Alice will confirm the correct care details for your finished garment.</p>
        </div>
      </details>
      <details class="ba-product-accordion">
        <summary><span>Making time, shipping &amp; returns</span></summary>
        <div class="ba-product-accordion__content">
          <p>Every piece is individually cut and sewn. Contact Alice before ordering when you need the garment by a particular date. Shipping is calculated at checkout.</p>
          <p class="ba-product-accordion__links"><a href="/pages/contact">Contact Alice</a><a href="/pages/shipping-returns">Shipping &amp; returns</a></p>
        </div>
      </details>`;

    information.querySelectorAll('details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        information.querySelectorAll('details[open]').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    buyButtons.insertAdjacentElement('afterend', information);
    productDetails.classList.add('ba-product-details--enhanced');

    if (descriptionBlock) {
      descriptionBlock.hidden = true;
      descriptionBlock.setAttribute('aria-hidden', 'true');
    }
  }

  function enhance(scope = document) {
    const builders = scope.querySelectorAll?.('[data-ba-order-builder]') || [];
    builders.forEach((builder) => {
      buildSizeButtons(builder);
      buildProductInformation(builder);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(), { once: true });
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
